import React from "react"
import { Link } from "./Link"
import Asset from "./Asset"
import { BodyWithTitle } from "@components/Teaser/Panel"
import feedTeaserFactory from "./factory"

export const Teaser = feedTeaserFactory({
  displayName: "Teaser",
  className: "content-feed-teaser",
  Content: Link,
})

export const TeaserVideo = feedTeaserFactory({
  displayName: "Video",
  className: "content-feed-video",
})

export const TeaserGalleryItem = feedTeaserFactory({
  displayName: "GalleryItem",
  className: "content-feed-gallery-item",
  Title: null,
  Body: BodyWithTitle,
  Content: Link,
  Asset: props => (
    <Asset
      {...props}
      imageProps={{
        className: "img-thumbnail",
        responsive: false,
        size: "w460",
      }}
    />
  ),
})
